export default __webpack_public_path__ + "static/media/tick-outlined.6a961d87.png";